module.exports = __webpack_public_path__ + "static/media/2.da684ad2.png";